import { render } from "./Main.vue?vue&type=template&id=356cbba5&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=356cbba5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-356cbba5"

export default script